import Themes from './lib/Themes';
import ThemeImage from './lib/ThemeImage.vue';

export default {
  install(app, options) {
    const themesPlugin = new Themes(options.theme);

    app.config.globalProperties.$theme = themesPlugin;
    themesPlugin.setFaviconAndTitle();

    app.component('theme-image', ThemeImage);
  },
};
